import Login from "./Login";
import ForgotPassword from "./ForgotPassword";
import LoginBySeedPhrase from "./LoginBySeedPhrase";

export {
	ForgotPassword,
	LoginBySeedPhrase
}
export default Login;